<template>
  <v-dialog v-model="dialog" :width="dialogWidth">
    <v-card>
      <v-card-text class="pa-0">
        <v-img :src="url" />
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn class="primary" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{$t('common.close')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ImageDialog",
  components: {},
  props: {
    url: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "600";
      }
      return "90%";
    }
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
    value: function () {
      // console.log("value changed to", val);
    },
  },
  created() {},
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    close() {
      this.$emit("input", this.user);
      this.dialog = false;
    },
  },
};
</script>
